<!--begin::Main-->
<div class="d-flex flex-column flex-root">
	<!--begin::Login-->
	<div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
		<!--begin::Aside-->
		<div class="login-aside d-flex flex-column flex-row-auto"
			style="box-shadow: inset -10px 0px 10px -10px rgba(0,0,0,0.5);">
			<!--begin::Aside Top-->

			<!--end::Aside Top-->
			<!--begin::Aside Bottom-->
			<div class="aside-img d-flex flex-row-fluid">
				<img src="assets/images/FPC.png" alt="FPC Image">
				<div class="caption">Veterinary Management</div>
			</div>
			<!--end::Aside Bottom-->

		</div>
		<div class="login-content flex-row-fluid d-flex flex-column p-10">
			<div class="d-flex flex-row-fluid flex-center">
				<!--begin::Login Sign in form-->
				<div class="login-form">
					<!--begin::Login Header-->
					<div class="login-content flex-row-fluid d-flex flex-column">
						<a href="#" class="login-logo pb-xl-15 pb-10">
							<span style="font-size:4rem;font-weight:600;color:#414e91 !important">Univet</span>
						</a>
					</div>
					<!--end::Login Header-->
					<form novalidate #formLogin="ngForm">
						<!-- <div class="pb-5 pb-lg-10">
							<h3 class="font-weight-bolder text-dark font-size-h5 ">Sign In</h3>
							<div class="text-muted font-weight-bold font-size-h6">New Here?
								<a href="javascript:;" class="text-success font-weight-bolder"
									style="color:#98a7e8 !important" (click)="Register()">Create Account</a>
							</div>
						</div> -->
						<h6>Welcome to FamilyPetCare</h6>
						<div class="form-group">
							<input type="email" name="Email" id="Email"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Email" required
								autofocus autocomplete="off" [(ngModel)]="accountService.login_user.Email">
							<!-- <div *ngIf="clicked && _loginForm.controls.Email.invalid" class="invalid-feedback">
										<div *ngIf="_loginForm.controls.Email.errors.required" class=" font-size-h6">Required</div>
										<div *ngIf="_loginForm.controls.Email.errors.email" class=" font-size-h6">Invalid Format</div>
	  								</div> -->
						</div>
						<div class="form-group">
							<input type="password" name="Password" id="Password"
								class="form-control h-auto  py-4 px-8 font-size-h6" placeholder="Password"
								(keyup.enter)="login()" required autocomplete="off"
								[(ngModel)]="accountService.login_user.Password">
							<!-- <div *ngIf="clicked && _loginForm.controls.Password.invalid" class="invalid-feedback">
								<div *ngIf="_loginForm.controls.Password.errors.required" class=" font-size-h6">Required
								</div>
							</div> -->
						</div>
						<div class="d-flex flex-stack flex-wrap font-size-h6 font-weight-bold mb-8 justify-content-end">
							<!--begin::Link-->
							<a href="javascript:;" class="text-success" (click)="ChangePassword()"
								style="color:#98a7e8 !important">Forget Password ?</a>
							<!--end::Link-->
						</div>
						<div class="form-group">
							<button type="button" class="btn btn-lg btn-block btn-success font-weight-bold font-size-h6"
								[disabled]="isAuthenticating || formLogin.invalid" type="button"
								style="background-color:#182845" (click)="login()">
								{{ isAuthenticating ? 'Signing in...' : 'Sign in' }} &nbsp;<i
									*ngIf="isAuthenticating === true" class="fas fa-spinner fa-spin"></i>
							</button>
						</div>
					</form>

				</div>
			</div>

		</div>

	</div>
</div>

<!--begin::Modal-->
<div class="modal fade" id="clinic_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
	aria-hidden="true" data-backdrop="static" data-keyboard="false">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">

			
			<!--begin::Modal Body-->
			<div class="modal-body text-center p-6">
				<img src="./assets/images/corgi_hello.png" alt="Modal Image" class="img-fluid mx-auto d-block mt-9 mb-2" style="max-height:250px;">
		
				<span class="d-block mb-3" style="font-size: 1.25rem; font-weight: 600;">
					Please choose a clinic to log in to.
				</span> 

				<div class="d-flex justify-content-center flex-wrap mt-3 mb-6">
					<button class="btn btn-outline-success d-flex align-items-center mx-2 mb-2" style="padding: 10px 20px;"
						*ngFor="let clinic of clinics" (click)="selectClinic(clinic.clinic_no, clinic.role)">
							<i [ngClass]="checkIcon(clinic.role)"></i>
							<div style="display: flex; flex-direction: column; text-align: center; margin-left: 10px;">
								<span>{{clinic.role_desc}}</span>
								<small style="font-size: 10px;">{{clinic.role === 1 ? 'Tenant Admin' : clinic.clinic_name}}</small>
							</div>
					</button>
				</div>
			</div>
			<!--end::Modal Body--> 

		</div> 
	</div>
</div>
<!--end::Modal-->